import { render, staticRenderFns } from "./createOrdersViewWizard.vue?vue&type=template&id=e67efcf2&"
import script from "./createOrdersViewWizard.vue?vue&type=script&lang=js&"
export * from "./createOrdersViewWizard.vue?vue&type=script&lang=js&"
import style0 from "./createOrdersViewWizard.vue?vue&type=style&index=0&id=e67efcf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports